import { Block } from "baseui/block";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useState } from "react";
import { useIntl } from 'react-intl';
import CalendarsList from "./CalendarsList";
import { TScheduler } from "../../types";
import { ICalendar } from "../../../Calendar";

const AddExceptionDialogForm = (props: {app: TScheduler, calendarsFilter(calendar: ICalendar): boolean, onChanged(eventPrio: number, calendar: ICalendar | undefined): void}) => {
    const intl = useIntl();
    const [selectedCalendar, setSelectedCalendar] = useState<any>();
    const [eventPrio, setEventPrio] = useState<number>(16);

    /*function onValueChanged(newValue: any) {
        props.setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            value: newValue
        }))
    }*/
    const onEventPrioChanged = (e: any) => {
        var num = parseInt(e.target.value);
        if ( num < 0) num = 0;
        if ( num > 16 ) num = 16;
        setEventPrio(num);
        props.onChanged(num,selectedCalendar);
    }

    const onCalendarSelected = (e: any) => {
        setSelectedCalendar(e);
        props.onChanged(eventPrio,e);
    }


    return (
        <Block display='flex' flexDirection='column' >
            <FormControl
                label={() => intl.formatMessage({ id: "Scheduler.eventPriority", defaultMessage: "Event Priority" })}
                caption={() => intl.formatMessage({ id: "Scheduler.eventPriorityDescr", defaultMessage: "Set a event Priority (0-16 ... 16 is highest) " })}
            >
                <Input type='number' value={eventPrio} onChange={onEventPrioChanged} required />
            </FormControl>
            <FormControl
                label={() => intl.formatMessage({ id: "Scheduler.selectCalendar", defaultMessage: "Select Calendar" })}
                caption={() => intl.formatMessage({ id: "Scheduler.selectCalendarDescr", defaultMessage: "Select a Calendar for the exception Schedule" })}
            >
                <CalendarsList calendarsFilter={props.calendarsFilter} app={props.app}  onItemSelected={onCalendarSelected} selected={selectedCalendar}></CalendarsList>
            </FormControl>
        </Block>
    );
};


export default AddExceptionDialogForm;